import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSystemConfig, setSystemConfig } from '@/api/system';
import { emailTest } from '@/api/email';
export default {
  name: 'Config',
  data: function data() {
    return {
      config: {
        system: {},
        jwt: {},
        casbin: {},
        mysql: {},
        sqlite: {},
        redis: {},
        qiniu: {},
        tencentCOS: {},
        aliyunOSS: {},
        captcha: {},
        zap: {},
        local: {},
        email: {}
      }
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return _this.initForm();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    initForm: function initForm() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getSystemConfig();
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.config = res.data.config;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    reload: function reload() {},
    update: function update() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return setSystemConfig({
                config: _this3.config
              });
            case 1:
              res = _context3.sent;
              if (!(res.code === 0)) {
                _context3.next = 2;
                break;
              }
              _this3.$message({
                type: 'success',
                message: '配置文件设置成功'
              });
              _context3.next = 2;
              return _this3.initForm();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    email: function email() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return emailTest();
            case 1:
              res = _context4.sent;
              if (!(res.code === 0)) {
                _context4.next = 3;
                break;
              }
              _this4.$message({
                type: 'success',
                message: '邮件发送成功'
              });
              _context4.next = 2;
              return _this4.initForm();
            case 2:
              _context4.next = 4;
              break;
            case 3:
              _this4.$message({
                type: 'error',
                message: '邮件发送失败'
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};